import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import './NewsAndPress.css'
import MoreImagesCard from '../../components/MoreImagesCard';
import { useParams } from 'react-router-dom';
import ChevronRight from '../../icons/ChevronRight';
import { useTranslation } from 'react-i18next';
import useLanguagePrefix from '../../LanguagePrefix';

function NewsAndPress() {
    const { t } = useTranslation();
    const langPrefix = useLanguagePrefix();
    const articlesPreviews = [
        { articlePath: ` /news/prostay-launches-a-new-standard-in-hotel-management-technology`, imgUrl: "/images/news.png", title: t("Prostay Launches: A New Standard in Hotel Management Technology"), description: t("Seamlessly enhance your platform with an API designed for flexibility, scalability, and seamless integration. Whether you’re expanding functionality, integrating third-....Seamlessly enhance your platform with an API designed for flexibility, scalability, and seamless integration. Whether you’re expanding functionality, integrating third-....Seamlessly enhance your platform with an API designed for flexibility, scalability, and seamless integration. Whether you’re expanding functionality, integrating third-...."), date: "06/04/2025" },
    ];

    return (
        <div>
            <Helmet>
                <title>Prostay – Latest Hospitality News & Press</title>
                <meta name="description" content="Stay updated with Prostay announcements, partnerships, and product news. Follow our journey from launch to innovation." />
                <link rel="canonical" href={"https://www.prostay.com" + langPrefix + "/news/"} />

                <link rel="alternate" href="https://www.prostay.com/en/news/" />
                <link rel="alternate" href="https://www.prostay.com/es/news/" />

                <meta property="og:title" content="Prostay – Latest Hospitality News & Press" />
                <meta property="og:description" content="Stay updated with Prostay announcements, partnerships, and product news. Follow our journey from launch to innovation." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={"https://www.prostay.com" + langPrefix + "/news/"}  />
                <meta property="og:image" content='https://prostay.com/images/ogImage.png' />

                <meta property="og:site_name" content="Prostay" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Prostay – Latest Hospitality News & Press" />
                <meta name="twitter:description" content="Stay updated with Prostay announcements, partnerships, and product news. Follow our journey from launch to innovation." />
                <meta name="twitter:image" content='https://prostay.com/images/ogImage.png' />
                <meta name="twitter:site" content="@prostaypms" />
                <meta name="twitter:creator" content="@prostaypms" />

            </Helmet>

            <div className='news-and-press'>
                <div className='background-image'>
                    <div className='background-image-start'>
                        <div className='d-flex align-items-center gap-2 gap-md-3 breadcrumbs'>
                            <a href={`${langPrefix}/`} style={{ textDecoration: 'none' }}><small style={{ cursor: 'pointer' }}>{t('Home')}</small></a>
                            <ChevronRight />
                            <small style={{ cursor: 'pointer', color: "#1643E0" }}>{t('News & Press')}</small>
                        </div>
                        <div className='mt-4' style={{ maxWidth: '600px' }}>
                            <h1>
                                {t('News & Press')}
                            </h1>
                        </div>
                    </div>
                </div>


                <div className='d-flex justify-content-center'>
                    <div className='page-content mt-2 mt-md-3'>
                        {
                            articlesPreviews.map(article =>
                                <div className='article-card'>
                                    <img src={article.imgUrl} />
                                    <div className='content'>
                                        <div className='d-flex mb-4 justify-content-between w-100 align-items-center'>
                                            <h5>{article.title}</h5>
                                            <small style={{ fontSize: 12, color: "#606576" }}>{article.date}</small>
                                        </div>
                                        <small className='body-small' style={{ color: "#606576" }}>
                                            {article.description}
                                        </small>
                                        <div className='d-flex justify-content-end mt-4'>
                                            <a href={article.articlePath+"/"} style={{ textDecoration: 'none' }}><button className='light-blue-filled-btn-small'>
                                                {t('Read More')}
                                                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13 5.99992H1Z" fill="white" />
                                                    <path d="M8.33333 1.33325L13 5.99992M13 5.99992L8.33333 10.6666M13 5.99992H1" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </button></a>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>


            </div>
        </div>
    );
}


export default NewsAndPress;
